module.exports = __webpack_public_path__ + "static/office-80a1c0485b88974311a25531766ad25a.jpg";